import { lazy, Suspense } from 'react';
import { GuestGuard } from '@emfood/shared';
import { Outlet, createRoute } from '@tanstack/react-router';

import AuthClassicLayout from 'src/layouts/auth/classic';

import { SplashScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

// Lazy load components
const JwtLoginPage = lazy(() => import('src/sections/auth/jwt/jwt-login-view'));
const JwtRegisterPage = lazy(() => import('src/sections/auth/jwt/jwt-register-view'));
const LoginCallbackPage = lazy(() => import('src/sections/auth/jwt/oauth-callback-view'));

// Create auth route (pathless/layout route)
const authRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'auth',
});

// Create JWT route (pathless/layout route for JWT-specific routes)
const jwtRoute = createRoute({
  getParentRoute: () => authRoute,
  path: 'jwt',
  component: () => (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
});

// Create login route
const loginRoute = createRoute({
  getParentRoute: () => jwtRoute,
  path: 'login',
  component: () => (
    <GuestGuard splashScreen={<SplashScreen />} returnToPath="/user-management">
      <AuthClassicLayout title="Welcome">
        <JwtLoginPage />
      </AuthClassicLayout>
    </GuestGuard>
  ),
});

// Create callback route
const callbackRoute = createRoute({
  getParentRoute: () => jwtRoute,
  path: 'callback',
  component: () => (
    <AuthClassicLayout>
      <LoginCallbackPage />
    </AuthClassicLayout>
  ),
});

// Create register route
const registerRoute = createRoute({
  getParentRoute: () => jwtRoute,
  path: 'register',
  component: () => (
    <GuestGuard splashScreen={<SplashScreen />} returnToPath="/user-managment">
      <AuthClassicLayout title="Welcome">
        <JwtRegisterPage />
      </AuthClassicLayout>
    </GuestGuard>
  ),
});

// Build the route tree
export const authRouteTree = authRoute.addChildren([
  jwtRoute.addChildren([loginRoute, callbackRoute, registerRoute]),
]);
